/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const updateProgramMemberships = /* GraphQL */ `mutation UpdateProgramMemberships($input: UpdateProgramMembershipsInput) {
  updateProgramMemberships(input: $input) {
    success
    message
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProgramMembershipsMutationVariables,
  APITypes.UpdateProgramMembershipsMutation
>;
export const submitAssessmentRequest = /* GraphQL */ `mutation SubmitAssessmentRequest($input: SubmitAssessmentRequestInput) {
  submitAssessmentRequest(input: $input) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitAssessmentRequestMutationVariables,
  APITypes.SubmitAssessmentRequestMutation
>;
export const bulkUpdatePgy = /* GraphQL */ `mutation BulkUpdatePgy($users: [UpdatePgyInput]) {
  bulkUpdatePgy(users: $users) {
    id
    email
    emailLower
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    cognitoUsername
    firstName
    lastName
    suffix
    npi
    simplLearnId
    pgy
    settings {
      sendEmail
      sendPushNotifications
      __typename
    }
    lastLogin
    eulaAcceptedDate
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deviceToken
    devicePlatform
    inviteId
    invite {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    jobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BulkUpdatePgyMutationVariables,
  APITypes.BulkUpdatePgyMutation
>;
export const completeAssessmentRequest = /* GraphQL */ `mutation CompleteAssessmentRequest($input: CompleteAssesessmentRequestInput) {
  completeAssessmentRequest(input: $input) {
    assessmentEvent {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      rater {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      raterUserId
      activityId
      activity {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      answers {
        items {
          id
          questionId
          valueType
          value
          assessmentEventId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDate
      completionDate
      declined
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    acgmeEnabled
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CompleteAssessmentRequestMutationVariables,
  APITypes.CompleteAssessmentRequestMutation
>;
export const declineAssessmentRequest = /* GraphQL */ `mutation DeclineAssessmentRequest($input: DeclineAssessmentRequestInput) {
  declineAssessmentRequest(input: $input) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeclineAssessmentRequestMutationVariables,
  APITypes.DeclineAssessmentRequestMutation
>;
export const createInstitution = /* GraphQL */ `mutation CreateInstitution(
  $input: CreateInstitutionInput!
  $condition: ModelInstitutionConditionInput
) {
  createInstitution(input: $input, condition: $condition) {
    id
    name
    description
    programs {
      items {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    users {
      items {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInstitutionMutationVariables,
  APITypes.CreateInstitutionMutation
>;
export const updateInstitution = /* GraphQL */ `mutation UpdateInstitution(
  $input: UpdateInstitutionInput!
  $condition: ModelInstitutionConditionInput
) {
  updateInstitution(input: $input, condition: $condition) {
    id
    name
    description
    programs {
      items {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    users {
      items {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInstitutionMutationVariables,
  APITypes.UpdateInstitutionMutation
>;
export const deleteInstitution = /* GraphQL */ `mutation DeleteInstitution(
  $input: DeleteInstitutionInput!
  $condition: ModelInstitutionConditionInput
) {
  deleteInstitution(input: $input, condition: $condition) {
    id
    name
    description
    programs {
      items {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    users {
      items {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInstitutionMutationVariables,
  APITypes.DeleteInstitutionMutation
>;
export const createProgram = /* GraphQL */ `mutation CreateProgram(
  $input: CreateProgramInput!
  $condition: ModelProgramConditionInput
) {
  createProgram(input: $input, condition: $condition) {
    id
    name
    description
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsors {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProgramMutationVariables,
  APITypes.CreateProgramMutation
>;
export const updateProgram = /* GraphQL */ `mutation UpdateProgram(
  $input: UpdateProgramInput!
  $condition: ModelProgramConditionInput
) {
  updateProgram(input: $input, condition: $condition) {
    id
    name
    description
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsors {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProgramMutationVariables,
  APITypes.UpdateProgramMutation
>;
export const deleteProgram = /* GraphQL */ `mutation DeleteProgram(
  $input: DeleteProgramInput!
  $condition: ModelProgramConditionInput
) {
  deleteProgram(input: $input, condition: $condition) {
    id
    name
    description
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsors {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProgramMutationVariables,
  APITypes.DeleteProgramMutation
>;
export const createNetwork = /* GraphQL */ `mutation CreateNetwork(
  $input: CreateNetworkInput!
  $condition: ModelNetworkConditionInput
) {
  createNetwork(input: $input, condition: $condition) {
    id
    name
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programs {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeEnabled
    allAttendingHistoryDisabled
    simpl1Id
    categoriesExcludedFromRequestFlow
    dashboardURL
    showDashboardLink
    disableClassicReports
    traineeCanRateTrainee
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNetworkMutationVariables,
  APITypes.CreateNetworkMutation
>;
export const updateNetwork = /* GraphQL */ `mutation UpdateNetwork(
  $input: UpdateNetworkInput!
  $condition: ModelNetworkConditionInput
) {
  updateNetwork(input: $input, condition: $condition) {
    id
    name
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programs {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeEnabled
    allAttendingHistoryDisabled
    simpl1Id
    categoriesExcludedFromRequestFlow
    dashboardURL
    showDashboardLink
    disableClassicReports
    traineeCanRateTrainee
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNetworkMutationVariables,
  APITypes.UpdateNetworkMutation
>;
export const deleteNetwork = /* GraphQL */ `mutation DeleteNetwork(
  $input: DeleteNetworkInput!
  $condition: ModelNetworkConditionInput
) {
  deleteNetwork(input: $input, condition: $condition) {
    id
    name
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programs {
      items {
        id
        programID
        networkID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeEnabled
    allAttendingHistoryDisabled
    simpl1Id
    categoriesExcludedFromRequestFlow
    dashboardURL
    showDashboardLink
    disableClassicReports
    traineeCanRateTrainee
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNetworkMutationVariables,
  APITypes.DeleteNetworkMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    email
    emailLower
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    cognitoUsername
    firstName
    lastName
    suffix
    npi
    simplLearnId
    pgy
    settings {
      sendEmail
      sendPushNotifications
      __typename
    }
    lastLogin
    eulaAcceptedDate
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deviceToken
    devicePlatform
    inviteId
    invite {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    jobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    email
    emailLower
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    cognitoUsername
    firstName
    lastName
    suffix
    npi
    simplLearnId
    pgy
    settings {
      sendEmail
      sendPushNotifications
      __typename
    }
    lastLogin
    eulaAcceptedDate
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deviceToken
    devicePlatform
    inviteId
    invite {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    jobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    email
    emailLower
    institutionId
    institution {
      id
      name
      description
      programs {
        items {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    cognitoUsername
    firstName
    lastName
    suffix
    npi
    simplLearnId
    pgy
    settings {
      sendEmail
      sendPushNotifications
      __typename
    }
    lastLogin
    eulaAcceptedDate
    programMemberships {
      items {
        id
        programRole
        traineeType
        programMemberId
        programId
        programMember {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        startDate
        endDate
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deviceToken
    devicePlatform
    inviteId
    invite {
      id
      inviteeId
      invitee {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      institutionId
      invitationStatus
      email
      emailLower
      adminId
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      role
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    jobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createUserInvitation = /* GraphQL */ `mutation CreateUserInvitation(
  $input: CreateUserInvitationInput!
  $condition: ModelUserInvitationConditionInput
) {
  createUserInvitation(input: $input, condition: $condition) {
    id
    inviteeId
    invitee {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    institutionId
    invitationStatus
    email
    emailLower
    adminId
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    role
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserInvitationMutationVariables,
  APITypes.CreateUserInvitationMutation
>;
export const updateUserInvitation = /* GraphQL */ `mutation UpdateUserInvitation(
  $input: UpdateUserInvitationInput!
  $condition: ModelUserInvitationConditionInput
) {
  updateUserInvitation(input: $input, condition: $condition) {
    id
    inviteeId
    invitee {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    institutionId
    invitationStatus
    email
    emailLower
    adminId
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    role
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserInvitationMutationVariables,
  APITypes.UpdateUserInvitationMutation
>;
export const deleteUserInvitation = /* GraphQL */ `mutation DeleteUserInvitation(
  $input: DeleteUserInvitationInput!
  $condition: ModelUserInvitationConditionInput
) {
  deleteUserInvitation(input: $input, condition: $condition) {
    id
    inviteeId
    invitee {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    institutionId
    invitationStatus
    email
    emailLower
    adminId
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    role
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserInvitationMutationVariables,
  APITypes.DeleteUserInvitationMutation
>;
export const createProgramMembership = /* GraphQL */ `mutation CreateProgramMembership(
  $input: CreateProgramMembershipInput!
  $condition: ModelProgramMembershipConditionInput
) {
  createProgramMembership(input: $input, condition: $condition) {
    id
    programRole
    traineeType
    programMemberId
    programId
    programMember {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    startDate
    endDate
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProgramMembershipMutationVariables,
  APITypes.CreateProgramMembershipMutation
>;
export const updateProgramMembership = /* GraphQL */ `mutation UpdateProgramMembership(
  $input: UpdateProgramMembershipInput!
  $condition: ModelProgramMembershipConditionInput
) {
  updateProgramMembership(input: $input, condition: $condition) {
    id
    programRole
    traineeType
    programMemberId
    programId
    programMember {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    startDate
    endDate
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProgramMembershipMutationVariables,
  APITypes.UpdateProgramMembershipMutation
>;
export const deleteProgramMembership = /* GraphQL */ `mutation DeleteProgramMembership(
  $input: DeleteProgramMembershipInput!
  $condition: ModelProgramMembershipConditionInput
) {
  deleteProgramMembership(input: $input, condition: $condition) {
    id
    programRole
    traineeType
    programMemberId
    programId
    programMember {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    startDate
    endDate
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProgramMembershipMutationVariables,
  APITypes.DeleteProgramMembershipMutation
>;
export const createEULAText = /* GraphQL */ `mutation CreateEULAText(
  $input: CreateEULATextInput!
  $condition: ModelEULATextConditionInput
) {
  createEULAText(input: $input, condition: $condition) {
    id
    formattedText
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEULATextMutationVariables,
  APITypes.CreateEULATextMutation
>;
export const updateEULAText = /* GraphQL */ `mutation UpdateEULAText(
  $input: UpdateEULATextInput!
  $condition: ModelEULATextConditionInput
) {
  updateEULAText(input: $input, condition: $condition) {
    id
    formattedText
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEULATextMutationVariables,
  APITypes.UpdateEULATextMutation
>;
export const deleteEULAText = /* GraphQL */ `mutation DeleteEULAText(
  $input: DeleteEULATextInput!
  $condition: ModelEULATextConditionInput
) {
  deleteEULAText(input: $input, condition: $condition) {
    id
    formattedText
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEULATextMutationVariables,
  APITypes.DeleteEULATextMutation
>;
export const createMilestone = /* GraphQL */ `mutation CreateMilestone(
  $input: CreateMilestoneInput!
  $condition: ModelMilestoneConditionInput
) {
  createMilestone(input: $input, condition: $condition) {
    id
    shortName
    name
    description
    scale
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMilestoneMutationVariables,
  APITypes.CreateMilestoneMutation
>;
export const updateMilestone = /* GraphQL */ `mutation UpdateMilestone(
  $input: UpdateMilestoneInput!
  $condition: ModelMilestoneConditionInput
) {
  updateMilestone(input: $input, condition: $condition) {
    id
    shortName
    name
    description
    scale
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMilestoneMutationVariables,
  APITypes.UpdateMilestoneMutation
>;
export const deleteMilestone = /* GraphQL */ `mutation DeleteMilestone(
  $input: DeleteMilestoneInput!
  $condition: ModelMilestoneConditionInput
) {
  deleteMilestone(input: $input, condition: $condition) {
    id
    shortName
    name
    description
    scale
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMilestoneMutationVariables,
  APITypes.DeleteMilestoneMutation
>;
export const createMilestoneNetworkRating = /* GraphQL */ `mutation CreateMilestoneNetworkRating(
  $input: CreateMilestoneNetworkRatingInput!
  $condition: ModelMilestoneNetworkRatingConditionInput
) {
  createMilestoneNetworkRating(input: $input, condition: $condition) {
    id
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    networkId
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneId
    milestone {
      id
      shortName
      name
      description
      scale
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answerOptionId
    answerOption {
      id
      anchor
      sortingIndex
      helpText
      value
      questionId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneRating
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMilestoneNetworkRatingMutationVariables,
  APITypes.CreateMilestoneNetworkRatingMutation
>;
export const updateMilestoneNetworkRating = /* GraphQL */ `mutation UpdateMilestoneNetworkRating(
  $input: UpdateMilestoneNetworkRatingInput!
  $condition: ModelMilestoneNetworkRatingConditionInput
) {
  updateMilestoneNetworkRating(input: $input, condition: $condition) {
    id
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    networkId
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneId
    milestone {
      id
      shortName
      name
      description
      scale
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answerOptionId
    answerOption {
      id
      anchor
      sortingIndex
      helpText
      value
      questionId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneRating
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMilestoneNetworkRatingMutationVariables,
  APITypes.UpdateMilestoneNetworkRatingMutation
>;
export const deleteMilestoneNetworkRating = /* GraphQL */ `mutation DeleteMilestoneNetworkRating(
  $input: DeleteMilestoneNetworkRatingInput!
  $condition: ModelMilestoneNetworkRatingConditionInput
) {
  deleteMilestoneNetworkRating(input: $input, condition: $condition) {
    id
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    networkId
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneId
    milestone {
      id
      shortName
      name
      description
      scale
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answerOptionId
    answerOption {
      id
      anchor
      sortingIndex
      helpText
      value
      questionId
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    milestoneRating
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMilestoneNetworkRatingMutationVariables,
  APITypes.DeleteMilestoneNetworkRatingMutation
>;
export const createSponsor = /* GraphQL */ `mutation CreateSponsor(
  $input: CreateSponsorInput!
  $condition: ModelSponsorConditionInput
) {
  createSponsor(input: $input, condition: $condition) {
    id
    name
    description
    programs {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        name
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programs {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        acgmeEnabled
        allAttendingHistoryDisabled
        simpl1Id
        categoriesExcludedFromRequestFlow
        dashboardURL
        showDashboardLink
        disableClassicReports
        traineeCanRateTrainee
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    branding {
      colors {
        primary
        secondary
        light
        __typename
      }
      logos {
        fullMono
        fullColor
        squareMono
        squareColor
        email
        __typename
      }
      __typename
    }
    activityLabel
    autoAssignActivities
    dashboardURL
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSponsorMutationVariables,
  APITypes.CreateSponsorMutation
>;
export const updateSponsor = /* GraphQL */ `mutation UpdateSponsor(
  $input: UpdateSponsorInput!
  $condition: ModelSponsorConditionInput
) {
  updateSponsor(input: $input, condition: $condition) {
    id
    name
    description
    programs {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        name
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programs {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        acgmeEnabled
        allAttendingHistoryDisabled
        simpl1Id
        categoriesExcludedFromRequestFlow
        dashboardURL
        showDashboardLink
        disableClassicReports
        traineeCanRateTrainee
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    branding {
      colors {
        primary
        secondary
        light
        __typename
      }
      logos {
        fullMono
        fullColor
        squareMono
        squareColor
        email
        __typename
      }
      __typename
    }
    activityLabel
    autoAssignActivities
    dashboardURL
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSponsorMutationVariables,
  APITypes.UpdateSponsorMutation
>;
export const deleteSponsor = /* GraphQL */ `mutation DeleteSponsor(
  $input: DeleteSponsorInput!
  $condition: ModelSponsorConditionInput
) {
  deleteSponsor(input: $input, condition: $condition) {
    id
    name
    description
    programs {
      items {
        id
        programID
        sponsorID
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    networks {
      items {
        id
        name
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programs {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        acgmeEnabled
        allAttendingHistoryDisabled
        simpl1Id
        categoriesExcludedFromRequestFlow
        dashboardURL
        showDashboardLink
        disableClassicReports
        traineeCanRateTrainee
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    branding {
      colors {
        primary
        secondary
        light
        __typename
      }
      logos {
        fullMono
        fullColor
        squareMono
        squareColor
        email
        __typename
      }
      __typename
    }
    activityLabel
    autoAssignActivities
    dashboardURL
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSponsorMutationVariables,
  APITypes.DeleteSponsorMutation
>;
export const createAssessment = /* GraphQL */ `mutation CreateAssessment(
  $input: CreateAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  createAssessment(input: $input, condition: $condition) {
    id
    title
    description
    instrumentId
    instrument {
      id
      title
      description
      questions {
        items {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    multiActivities {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDurationHours
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    requireTraineeSelfAssessment
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    published
    archived
    version
    creationDurationHours
    showFeedbackQuestionsToTrainees
    sendEmailForSelfAssessment
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentMutationVariables,
  APITypes.CreateAssessmentMutation
>;
export const updateAssessment = /* GraphQL */ `mutation UpdateAssessment(
  $input: UpdateAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  updateAssessment(input: $input, condition: $condition) {
    id
    title
    description
    instrumentId
    instrument {
      id
      title
      description
      questions {
        items {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    multiActivities {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDurationHours
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    requireTraineeSelfAssessment
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    published
    archived
    version
    creationDurationHours
    showFeedbackQuestionsToTrainees
    sendEmailForSelfAssessment
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentMutationVariables,
  APITypes.UpdateAssessmentMutation
>;
export const deleteAssessment = /* GraphQL */ `mutation DeleteAssessment(
  $input: DeleteAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  deleteAssessment(input: $input, condition: $condition) {
    id
    title
    description
    instrumentId
    instrument {
      id
      title
      description
      questions {
        items {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    multiActivities {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDurationHours
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    requireTraineeSelfAssessment
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    published
    archived
    version
    creationDurationHours
    showFeedbackQuestionsToTrainees
    sendEmailForSelfAssessment
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentMutationVariables,
  APITypes.DeleteAssessmentMutation
>;
export const createInstrument = /* GraphQL */ `mutation CreateInstrument(
  $input: CreateInstrumentInput!
  $condition: ModelInstrumentConditionInput
) {
  createInstrument(input: $input, condition: $condition) {
    id
    title
    description
    questions {
      items {
        id
        defaultPrompt
        required
        selfAssessmentPrompt
        sortingIndex
        title
        helpText
        inputType
        instrumentId
        answerOptions {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInstrumentMutationVariables,
  APITypes.CreateInstrumentMutation
>;
export const updateInstrument = /* GraphQL */ `mutation UpdateInstrument(
  $input: UpdateInstrumentInput!
  $condition: ModelInstrumentConditionInput
) {
  updateInstrument(input: $input, condition: $condition) {
    id
    title
    description
    questions {
      items {
        id
        defaultPrompt
        required
        selfAssessmentPrompt
        sortingIndex
        title
        helpText
        inputType
        instrumentId
        answerOptions {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInstrumentMutationVariables,
  APITypes.UpdateInstrumentMutation
>;
export const deleteInstrument = /* GraphQL */ `mutation DeleteInstrument(
  $input: DeleteInstrumentInput!
  $condition: ModelInstrumentConditionInput
) {
  deleteInstrument(input: $input, condition: $condition) {
    id
    title
    description
    questions {
      items {
        id
        defaultPrompt
        required
        selfAssessmentPrompt
        sortingIndex
        title
        helpText
        inputType
        instrumentId
        answerOptions {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInstrumentMutationVariables,
  APITypes.DeleteInstrumentMutation
>;
export const createActivity = /* GraphQL */ `mutation CreateActivity(
  $input: CreateActivityInput!
  $condition: ModelActivityConditionInput
) {
  createActivity(input: $input, condition: $condition) {
    id
    title
    description
    subActivities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessments {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activityEvents {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    networks {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeProcedures {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    categories
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    activitySubActivitiesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateActivityMutationVariables,
  APITypes.CreateActivityMutation
>;
export const updateActivity = /* GraphQL */ `mutation UpdateActivity(
  $input: UpdateActivityInput!
  $condition: ModelActivityConditionInput
) {
  updateActivity(input: $input, condition: $condition) {
    id
    title
    description
    subActivities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessments {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activityEvents {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    networks {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeProcedures {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    categories
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    activitySubActivitiesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateActivityMutationVariables,
  APITypes.UpdateActivityMutation
>;
export const deleteActivity = /* GraphQL */ `mutation DeleteActivity(
  $input: DeleteActivityInput!
  $condition: ModelActivityConditionInput
) {
  deleteActivity(input: $input, condition: $condition) {
    id
    title
    description
    subActivities {
      items {
        id
        title
        description
        subActivities {
          nextToken
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessments {
          nextToken
          __typename
        }
        activityEvents {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        networks {
          nextToken
          __typename
        }
        acgmeProcedures {
          nextToken
          __typename
        }
        simpl1Id
        categories
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      nextToken
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessments {
      items {
        id
        assessmentID
        activityID
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activityEvents {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sponsorId
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    authorId
    author {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    version
    networks {
      items {
        id
        networkID
        activityID
        network {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    acgmeProcedures {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    categories
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    activitySubActivitiesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteActivityMutationVariables,
  APITypes.DeleteActivityMutation
>;
export const createQuestion = /* GraphQL */ `mutation CreateQuestion(
  $input: CreateQuestionInput!
  $condition: ModelQuestionConditionInput
) {
  createQuestion(input: $input, condition: $condition) {
    id
    defaultPrompt
    required
    selfAssessmentPrompt
    sortingIndex
    title
    helpText
    inputType
    instrumentId
    answerOptions {
      items {
        id
        anchor
        sortingIndex
        helpText
        value
        questionId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQuestionMutationVariables,
  APITypes.CreateQuestionMutation
>;
export const updateQuestion = /* GraphQL */ `mutation UpdateQuestion(
  $input: UpdateQuestionInput!
  $condition: ModelQuestionConditionInput
) {
  updateQuestion(input: $input, condition: $condition) {
    id
    defaultPrompt
    required
    selfAssessmentPrompt
    sortingIndex
    title
    helpText
    inputType
    instrumentId
    answerOptions {
      items {
        id
        anchor
        sortingIndex
        helpText
        value
        questionId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQuestionMutationVariables,
  APITypes.UpdateQuestionMutation
>;
export const deleteQuestion = /* GraphQL */ `mutation DeleteQuestion(
  $input: DeleteQuestionInput!
  $condition: ModelQuestionConditionInput
) {
  deleteQuestion(input: $input, condition: $condition) {
    id
    defaultPrompt
    required
    selfAssessmentPrompt
    sortingIndex
    title
    helpText
    inputType
    instrumentId
    answerOptions {
      items {
        id
        anchor
        sortingIndex
        helpText
        value
        questionId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteQuestionMutationVariables,
  APITypes.DeleteQuestionMutation
>;
export const createAnswerOption = /* GraphQL */ `mutation CreateAnswerOption(
  $input: CreateAnswerOptionInput!
  $condition: ModelAnswerOptionConditionInput
) {
  createAnswerOption(input: $input, condition: $condition) {
    id
    anchor
    sortingIndex
    helpText
    value
    questionId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAnswerOptionMutationVariables,
  APITypes.CreateAnswerOptionMutation
>;
export const updateAnswerOption = /* GraphQL */ `mutation UpdateAnswerOption(
  $input: UpdateAnswerOptionInput!
  $condition: ModelAnswerOptionConditionInput
) {
  updateAnswerOption(input: $input, condition: $condition) {
    id
    anchor
    sortingIndex
    helpText
    value
    questionId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAnswerOptionMutationVariables,
  APITypes.UpdateAnswerOptionMutation
>;
export const deleteAnswerOption = /* GraphQL */ `mutation DeleteAnswerOption(
  $input: DeleteAnswerOptionInput!
  $condition: ModelAnswerOptionConditionInput
) {
  deleteAnswerOption(input: $input, condition: $condition) {
    id
    anchor
    sortingIndex
    helpText
    value
    questionId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAnswerOptionMutationVariables,
  APITypes.DeleteAnswerOptionMutation
>;
export const createActivityEvent = /* GraphQL */ `mutation CreateActivityEvent(
  $input: CreateActivityEventInput!
  $condition: ModelActivityEventConditionInput
) {
  createActivityEvent(input: $input, condition: $condition) {
    id
    creatorId
    creator {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    participants {
      items {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventDate
    notes
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateActivityEventMutationVariables,
  APITypes.CreateActivityEventMutation
>;
export const updateActivityEvent = /* GraphQL */ `mutation UpdateActivityEvent(
  $input: UpdateActivityEventInput!
  $condition: ModelActivityEventConditionInput
) {
  updateActivityEvent(input: $input, condition: $condition) {
    id
    creatorId
    creator {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    participants {
      items {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventDate
    notes
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateActivityEventMutationVariables,
  APITypes.UpdateActivityEventMutation
>;
export const deleteActivityEvent = /* GraphQL */ `mutation DeleteActivityEvent(
  $input: DeleteActivityEventInput!
  $condition: ModelActivityEventConditionInput
) {
  deleteActivityEvent(input: $input, condition: $condition) {
    id
    creatorId
    creator {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    participants {
      items {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        currentPGY
        currentRole
        currentTraineeType
        currentJobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    activities {
      items {
        id
        activityID
        activityEventID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    assessmentEvents {
      items {
        id
        subjectId
        subject {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          expirationDurationHours
          sponsorId
          requireTraineeSelfAssessment
          authorId
          published
          archived
          version
          creationDurationHours
          showFeedbackQuestionsToTrainees
          sendEmailForSelfAssessment
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        answers {
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventDate
    notes
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteActivityEventMutationVariables,
  APITypes.DeleteActivityEventMutation
>;
export const createActivityParticipant = /* GraphQL */ `mutation CreateActivityParticipant(
  $input: CreateActivityParticipantInput!
  $condition: ModelActivityParticipantConditionInput
) {
  createActivityParticipant(input: $input, condition: $condition) {
    id
    userId
    user {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    currentPGY
    currentRole
    currentTraineeType
    currentJobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateActivityParticipantMutationVariables,
  APITypes.CreateActivityParticipantMutation
>;
export const updateActivityParticipant = /* GraphQL */ `mutation UpdateActivityParticipant(
  $input: UpdateActivityParticipantInput!
  $condition: ModelActivityParticipantConditionInput
) {
  updateActivityParticipant(input: $input, condition: $condition) {
    id
    userId
    user {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    currentPGY
    currentRole
    currentTraineeType
    currentJobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateActivityParticipantMutationVariables,
  APITypes.UpdateActivityParticipantMutation
>;
export const deleteActivityParticipant = /* GraphQL */ `mutation DeleteActivityParticipant(
  $input: DeleteActivityParticipantInput!
  $condition: ModelActivityParticipantConditionInput
) {
  deleteActivityParticipant(input: $input, condition: $condition) {
    id
    userId
    user {
      id
      email
      emailLower
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      cognitoUsername
      firstName
      lastName
      suffix
      npi
      simplLearnId
      pgy
      settings {
        sendEmail
        sendPushNotifications
        __typename
      }
      lastLogin
      eulaAcceptedDate
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deviceToken
      devicePlatform
      inviteId
      invite {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        role
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      jobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    currentPGY
    currentRole
    currentTraineeType
    currentJobTitle
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteActivityParticipantMutationVariables,
  APITypes.DeleteActivityParticipantMutation
>;
export const createAssessmentEvent = /* GraphQL */ `mutation CreateAssessmentEvent(
  $input: CreateAssessmentEventInput!
  $condition: ModelAssessmentEventConditionInput
) {
  createAssessmentEvent(input: $input, condition: $condition) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentEventMutationVariables,
  APITypes.CreateAssessmentEventMutation
>;
export const updateAssessmentEvent = /* GraphQL */ `mutation UpdateAssessmentEvent(
  $input: UpdateAssessmentEventInput!
  $condition: ModelAssessmentEventConditionInput
) {
  updateAssessmentEvent(input: $input, condition: $condition) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentEventMutationVariables,
  APITypes.UpdateAssessmentEventMutation
>;
export const deleteAssessmentEvent = /* GraphQL */ `mutation DeleteAssessmentEvent(
  $input: DeleteAssessmentEventInput!
  $condition: ModelAssessmentEventConditionInput
) {
  deleteAssessmentEvent(input: $input, condition: $condition) {
    id
    subjectId
    subject {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    subjectUserId
    raterId
    rater {
      id
      userId
      user {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        creator {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        participants {
          nextToken
          __typename
        }
        activities {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activityEventDate
        notes
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programId
      currentPGY
      currentRole
      currentTraineeType
      currentJobTitle
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    raterUserId
    activityId
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEventId
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    assessmentId
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    answers {
      items {
        id
        questionId
        question {
          id
          defaultPrompt
          required
          selfAssessmentPrompt
          sortingIndex
          title
          helpText
          inputType
          instrumentId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        valueType
        value
        assessmentEventId
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    expirationDate
    completionDate
    declined
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentEventMutationVariables,
  APITypes.DeleteAssessmentEventMutation
>;
export const createAnswerEvent = /* GraphQL */ `mutation CreateAnswerEvent(
  $input: CreateAnswerEventInput!
  $condition: ModelAnswerEventConditionInput
) {
  createAnswerEvent(input: $input, condition: $condition) {
    id
    questionId
    question {
      id
      defaultPrompt
      required
      selfAssessmentPrompt
      sortingIndex
      title
      helpText
      inputType
      instrumentId
      answerOptions {
        items {
          id
          anchor
          sortingIndex
          helpText
          value
          questionId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    valueType
    value
    assessmentEventId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAnswerEventMutationVariables,
  APITypes.CreateAnswerEventMutation
>;
export const updateAnswerEvent = /* GraphQL */ `mutation UpdateAnswerEvent(
  $input: UpdateAnswerEventInput!
  $condition: ModelAnswerEventConditionInput
) {
  updateAnswerEvent(input: $input, condition: $condition) {
    id
    questionId
    question {
      id
      defaultPrompt
      required
      selfAssessmentPrompt
      sortingIndex
      title
      helpText
      inputType
      instrumentId
      answerOptions {
        items {
          id
          anchor
          sortingIndex
          helpText
          value
          questionId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    valueType
    value
    assessmentEventId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAnswerEventMutationVariables,
  APITypes.UpdateAnswerEventMutation
>;
export const deleteAnswerEvent = /* GraphQL */ `mutation DeleteAnswerEvent(
  $input: DeleteAnswerEventInput!
  $condition: ModelAnswerEventConditionInput
) {
  deleteAnswerEvent(input: $input, condition: $condition) {
    id
    questionId
    question {
      id
      defaultPrompt
      required
      selfAssessmentPrompt
      sortingIndex
      title
      helpText
      inputType
      instrumentId
      answerOptions {
        items {
          id
          anchor
          sortingIndex
          helpText
          value
          questionId
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    valueType
    value
    assessmentEventId
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAnswerEventMutationVariables,
  APITypes.DeleteAnswerEventMutation
>;
export const createAcgmeProcedure = /* GraphQL */ `mutation CreateAcgmeProcedure(
  $input: CreateAcgmeProcedureInput!
  $condition: ModelAcgmeProcedureConditionInput
) {
  createAcgmeProcedure(input: $input, condition: $condition) {
    id
    name
    acgmeCode
    activities {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAcgmeProcedureMutationVariables,
  APITypes.CreateAcgmeProcedureMutation
>;
export const updateAcgmeProcedure = /* GraphQL */ `mutation UpdateAcgmeProcedure(
  $input: UpdateAcgmeProcedureInput!
  $condition: ModelAcgmeProcedureConditionInput
) {
  updateAcgmeProcedure(input: $input, condition: $condition) {
    id
    name
    acgmeCode
    activities {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAcgmeProcedureMutationVariables,
  APITypes.UpdateAcgmeProcedureMutation
>;
export const deleteAcgmeProcedure = /* GraphQL */ `mutation DeleteAcgmeProcedure(
  $input: DeleteAcgmeProcedureInput!
  $condition: ModelAcgmeProcedureConditionInput
) {
  deleteAcgmeProcedure(input: $input, condition: $condition) {
    id
    name
    acgmeCode
    activities {
      items {
        id
        activityID
        acgmeProcedureID
        activity {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        acgmeProcedure {
          id
          name
          acgmeCode
          simpl1Id
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    simpl1Id
    deletedAt
    deletedBy
    deletedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAcgmeProcedureMutationVariables,
  APITypes.DeleteAcgmeProcedureMutation
>;
export const createProgramSponsors = /* GraphQL */ `mutation CreateProgramSponsors(
  $input: CreateProgramSponsorsInput!
  $condition: ModelProgramSponsorsConditionInput
) {
  createProgramSponsors(input: $input, condition: $condition) {
    id
    programID
    sponsorID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProgramSponsorsMutationVariables,
  APITypes.CreateProgramSponsorsMutation
>;
export const updateProgramSponsors = /* GraphQL */ `mutation UpdateProgramSponsors(
  $input: UpdateProgramSponsorsInput!
  $condition: ModelProgramSponsorsConditionInput
) {
  updateProgramSponsors(input: $input, condition: $condition) {
    id
    programID
    sponsorID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProgramSponsorsMutationVariables,
  APITypes.UpdateProgramSponsorsMutation
>;
export const deleteProgramSponsors = /* GraphQL */ `mutation DeleteProgramSponsors(
  $input: DeleteProgramSponsorsInput!
  $condition: ModelProgramSponsorsConditionInput
) {
  deleteProgramSponsors(input: $input, condition: $condition) {
    id
    programID
    sponsorID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    sponsor {
      id
      name
      description
      programs {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          name
          sponsorId
          acgmeEnabled
          allAttendingHistoryDisabled
          simpl1Id
          categoriesExcludedFromRequestFlow
          dashboardURL
          showDashboardLink
          disableClassicReports
          traineeCanRateTrainee
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          email
          __typename
        }
        __typename
      }
      activityLabel
      autoAssignActivities
      dashboardURL
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProgramSponsorsMutationVariables,
  APITypes.DeleteProgramSponsorsMutation
>;
export const createNetworkProgram = /* GraphQL */ `mutation CreateNetworkProgram(
  $input: CreateNetworkProgramInput!
  $condition: ModelNetworkProgramConditionInput
) {
  createNetworkProgram(input: $input, condition: $condition) {
    id
    programID
    networkID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNetworkProgramMutationVariables,
  APITypes.CreateNetworkProgramMutation
>;
export const updateNetworkProgram = /* GraphQL */ `mutation UpdateNetworkProgram(
  $input: UpdateNetworkProgramInput!
  $condition: ModelNetworkProgramConditionInput
) {
  updateNetworkProgram(input: $input, condition: $condition) {
    id
    programID
    networkID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNetworkProgramMutationVariables,
  APITypes.UpdateNetworkProgramMutation
>;
export const deleteNetworkProgram = /* GraphQL */ `mutation DeleteNetworkProgram(
  $input: DeleteNetworkProgramInput!
  $condition: ModelNetworkProgramConditionInput
) {
  deleteNetworkProgram(input: $input, condition: $condition) {
    id
    programID
    networkID
    program {
      id
      name
      description
      institutionId
      institution {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programMemberships {
        items {
          id
          programRole
          traineeType
          programMemberId
          programId
          startDate
          endDate
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsors {
        items {
          id
          programID
          sponsorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      networks {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNetworkProgramMutationVariables,
  APITypes.DeleteNetworkProgramMutation
>;
export const createNetworkActivity = /* GraphQL */ `mutation CreateNetworkActivity(
  $input: CreateNetworkActivityInput!
  $condition: ModelNetworkActivityConditionInput
) {
  createNetworkActivity(input: $input, condition: $condition) {
    id
    networkID
    activityID
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNetworkActivityMutationVariables,
  APITypes.CreateNetworkActivityMutation
>;
export const updateNetworkActivity = /* GraphQL */ `mutation UpdateNetworkActivity(
  $input: UpdateNetworkActivityInput!
  $condition: ModelNetworkActivityConditionInput
) {
  updateNetworkActivity(input: $input, condition: $condition) {
    id
    networkID
    activityID
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNetworkActivityMutationVariables,
  APITypes.UpdateNetworkActivityMutation
>;
export const deleteNetworkActivity = /* GraphQL */ `mutation DeleteNetworkActivity(
  $input: DeleteNetworkActivityInput!
  $condition: ModelNetworkActivityConditionInput
) {
  deleteNetworkActivity(input: $input, condition: $condition) {
    id
    networkID
    activityID
    network {
      id
      name
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      programs {
        items {
          id
          programID
          networkID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeEnabled
      allAttendingHistoryDisabled
      simpl1Id
      categoriesExcludedFromRequestFlow
      dashboardURL
      showDashboardLink
      disableClassicReports
      traineeCanRateTrainee
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNetworkActivityMutationVariables,
  APITypes.DeleteNetworkActivityMutation
>;
export const createAssessmentActivity = /* GraphQL */ `mutation CreateAssessmentActivity(
  $input: CreateAssessmentActivityInput!
  $condition: ModelAssessmentActivityConditionInput
) {
  createAssessmentActivity(input: $input, condition: $condition) {
    id
    assessmentID
    activityID
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentActivityMutationVariables,
  APITypes.CreateAssessmentActivityMutation
>;
export const updateAssessmentActivity = /* GraphQL */ `mutation UpdateAssessmentActivity(
  $input: UpdateAssessmentActivityInput!
  $condition: ModelAssessmentActivityConditionInput
) {
  updateAssessmentActivity(input: $input, condition: $condition) {
    id
    assessmentID
    activityID
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentActivityMutationVariables,
  APITypes.UpdateAssessmentActivityMutation
>;
export const deleteAssessmentActivity = /* GraphQL */ `mutation DeleteAssessmentActivity(
  $input: DeleteAssessmentActivityInput!
  $condition: ModelAssessmentActivityConditionInput
) {
  deleteAssessmentActivity(input: $input, condition: $condition) {
    id
    assessmentID
    activityID
    assessment {
      id
      title
      description
      instrumentId
      instrument {
        id
        title
        description
        questions {
          nextToken
          __typename
        }
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        version
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      multiActivities {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirationDurationHours
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      requireTraineeSelfAssessment
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentActivityMutationVariables,
  APITypes.DeleteAssessmentActivityMutation
>;
export const createActivityEventActivities = /* GraphQL */ `mutation CreateActivityEventActivities(
  $input: CreateActivityEventActivitiesInput!
  $condition: ModelActivityEventActivitiesConditionInput
) {
  createActivityEventActivities(input: $input, condition: $condition) {
    id
    activityID
    activityEventID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateActivityEventActivitiesMutationVariables,
  APITypes.CreateActivityEventActivitiesMutation
>;
export const updateActivityEventActivities = /* GraphQL */ `mutation UpdateActivityEventActivities(
  $input: UpdateActivityEventActivitiesInput!
  $condition: ModelActivityEventActivitiesConditionInput
) {
  updateActivityEventActivities(input: $input, condition: $condition) {
    id
    activityID
    activityEventID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateActivityEventActivitiesMutationVariables,
  APITypes.UpdateActivityEventActivitiesMutation
>;
export const deleteActivityEventActivities = /* GraphQL */ `mutation DeleteActivityEventActivities(
  $input: DeleteActivityEventActivitiesInput!
  $condition: ModelActivityEventActivitiesConditionInput
) {
  deleteActivityEventActivities(input: $input, condition: $condition) {
    id
    activityID
    activityEventID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    activityEvent {
      id
      creatorId
      creator {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      participants {
        items {
          id
          userId
          activityEventId
          programId
          currentPGY
          currentRole
          currentTraineeType
          currentJobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      programId
      program {
        id
        name
        description
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        programMemberships {
          nextToken
          __typename
        }
        assessmentEvents {
          nextToken
          __typename
        }
        sponsors {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        simpl1Id
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      activityEventDate
      notes
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteActivityEventActivitiesMutationVariables,
  APITypes.DeleteActivityEventActivitiesMutation
>;
export const createAcgmeProcedureActivity = /* GraphQL */ `mutation CreateAcgmeProcedureActivity(
  $input: CreateAcgmeProcedureActivityInput!
  $condition: ModelAcgmeProcedureActivityConditionInput
) {
  createAcgmeProcedureActivity(input: $input, condition: $condition) {
    id
    activityID
    acgmeProcedureID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    acgmeProcedure {
      id
      name
      acgmeCode
      activities {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAcgmeProcedureActivityMutationVariables,
  APITypes.CreateAcgmeProcedureActivityMutation
>;
export const updateAcgmeProcedureActivity = /* GraphQL */ `mutation UpdateAcgmeProcedureActivity(
  $input: UpdateAcgmeProcedureActivityInput!
  $condition: ModelAcgmeProcedureActivityConditionInput
) {
  updateAcgmeProcedureActivity(input: $input, condition: $condition) {
    id
    activityID
    acgmeProcedureID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    acgmeProcedure {
      id
      name
      acgmeCode
      activities {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAcgmeProcedureActivityMutationVariables,
  APITypes.UpdateAcgmeProcedureActivityMutation
>;
export const deleteAcgmeProcedureActivity = /* GraphQL */ `mutation DeleteAcgmeProcedureActivity(
  $input: DeleteAcgmeProcedureActivityInput!
  $condition: ModelAcgmeProcedureActivityConditionInput
) {
  deleteAcgmeProcedureActivity(input: $input, condition: $condition) {
    id
    activityID
    acgmeProcedureID
    activity {
      id
      title
      description
      subActivities {
        items {
          id
          title
          description
          assessmentId
          sponsorId
          authorId
          version
          simpl1Id
          categories
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        nextToken
        __typename
      }
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        instrument {
          id
          title
          description
          authorId
          version
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        activities {
          nextToken
          __typename
        }
        multiActivities {
          nextToken
          __typename
        }
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          activityLabel
          autoAssignActivities
          dashboardURL
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        author {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          simplLearnId
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          jobTitle
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      assessments {
        items {
          id
          assessmentID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activityEvents {
        items {
          id
          activityID
          activityEventID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assessmentEvents {
        items {
          id
          subjectId
          subjectUserId
          raterId
          raterUserId
          activityId
          activityEventId
          programId
          assessmentId
          expirationDate
          completionDate
          declined
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      sponsorId
      sponsor {
        id
        name
        description
        programs {
          nextToken
          __typename
        }
        networks {
          nextToken
          __typename
        }
        branding {
          __typename
        }
        activityLabel
        autoAssignActivities
        dashboardURL
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      authorId
      author {
        id
        email
        emailLower
        institutionId
        institution {
          id
          name
          description
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        simplLearnId
        pgy
        settings {
          sendEmail
          sendPushNotifications
          __typename
        }
        lastLogin
        eulaAcceptedDate
        programMemberships {
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        invite {
          id
          inviteeId
          institutionId
          invitationStatus
          email
          emailLower
          adminId
          programId
          role
          deletedAt
          deletedBy
          deletedReason
          createdAt
          updatedAt
          __typename
        }
        jobTitle
        deletedAt
        deletedBy
        deletedReason
        createdAt
        updatedAt
        __typename
      }
      version
      networks {
        items {
          id
          networkID
          activityID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      acgmeProcedures {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      categories
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      activitySubActivitiesId
      __typename
    }
    acgmeProcedure {
      id
      name
      acgmeCode
      activities {
        items {
          id
          activityID
          acgmeProcedureID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      simpl1Id
      deletedAt
      deletedBy
      deletedReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAcgmeProcedureActivityMutationVariables,
  APITypes.DeleteAcgmeProcedureActivityMutation
>;
